<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">营业查询</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="企业名称" prop="Sender">
            <el-input v-model="Sender" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="日期" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 68rem"
              unlink-panels
            ></el-date-picker>
          </el-form-item>

          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button v-if="isAdd" size="mini" @click="onAdd">填 报</el-button>
          <!-- <el-button size="mini" @click="onbatchDel">删 除</el-button> -->
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              v-loading="loading"
              element-loading-text="搜索中"
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center">
              </el-table-column>
              <el-table-column prop="CompanyName" label="企业名称"></el-table-column>
              <el-table-column
                prop="ReportDate"
                label="填报日期"
                :formatter="formatDate"
                width="200"
              ></el-table-column>
              <!-- <el-table-column prop="TimeSolt" label="填报时间段">
                <template slot-scope="scope">
                  <span v-if="scope.row.TimeSolt == '0'">上午</span>
                  <span v-else-if="scope.row.TimeSolt == '1'">下午</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="TicketData" label="售票数"></el-table-column>
              <el-table-column prop="Income" label="售票金额"></el-table-column>
              <el-table-column prop="VisitorData" label="接待游客量"></el-table-column>
              <el-table-column prop="OutGardenNum" label="出园游客量"></el-table-column>
              <el-table-column prop="Turnover" label="全园经济收入"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="LookDetail(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button
                    @click="EditDetail(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >编辑</el-button>
                  <!-- <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import moment from 'moment'
// import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import waitAll from "../../../../../../utils/src/waitAll";
import Apis from "../../../../../../api";
export default {
  name: "ScenicList",
  controller: "UI",
  action: "ScenicList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      Sender: "",
      date: [],
      isAdd: true,
      curDate: '',
      dialogVisible: false,
      loading: false,
      loadingText: "加载中...",
      IsAdministrator: false,
    };
  },
  created: function () {
    this.curDate = moment().format('YYYY-MM-DD')
    //当前设定的日期时间
    let d = new Date();
    let year1, month1, day1;
    [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
    let date1 = new Date(year1, month1, day1, 7);
    this.date.push(date1);
    //前一天设定的日期时间
    let year2, month2, day2;
    d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
    [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
    let date2 = new Date(year2, month2, day2, 7);
    this.date.unshift(date2);
    
  },
  mounted: function () {
    this.GetUserIsAdministrator();
   
  },
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
     GetUserIsAdministrator() {
      let user = this.user;
      var userId = user.UserId;
      let RoleInfoSearch = {
        UserId: userId,
      };
      new Apis.RoleApi()
        .IsAdministrator(RoleInfoSearch)
        .then((r) => {
          r = r.data.Data;
          this.IsAdministrator = r;
          this.search(true);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search(flag) {
      let searchInfo = {
        CpyName: this.Sender,
        CompanyId: this.IsAdministrator?"":this.user.Departments[0].OrgId,
        ReportStartTime: this.date.length==0 ? null : new Date(this.date[0]).format("yyyy-MM-dd"),
        ReportEndTime: this.date.length==0 ? null : new Date(this.date[1]).format("yyyy-MM-dd"),
        PageSize: this.pageSize,
        PageIndex: this.currentPage
      };
      new MyApis.TbTourScenicApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          let data = r.data
          if (data.RspCode === '1') {
            this.tableData = []
            if (data.Data && data.Data.PageContents.length > 0) {
              this.tableData = data.Data.PageContents.map(item => {
                item.ReportDate = moment(item.ReportDate).format('YYYY-MM-DD')
                if (this.curDate === item.ReportDate) {
                  if (flag) {
                    this.isAdd = false
                  }
                  item.isEdit = true
                } else {
                  item.isEdit = false
                }
                return item
              });
              this.total = data.Data.BaseSearch.TotalCount;
            }
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.Sender = "";
      this.date = [];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/ScenicAdd",
        query: {
          type: "add"
        },
      });
    },
    LookDetail(index, row) {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/ScenicAdd",
        query: {
          InfoId: row.ID,
          type: "look"
        }
      });
    },
    EditDetail(index, row) {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/ScenicAdd",
        query: {
          InfoId: row.ID,
          type: "edit"
        },
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            var arr = [];
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              selectData.forEach((item) => {
                new MyApis.TbTourScenicApi()
                  .DelItem(item)
                  .then((r) => {
                    r = r.data.Data;
                    arr.push(r);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              });
              waitAll(arr)
                .then((r) => {
                  // resolve(r);
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    this.search();
                  }
                })
                .catch((e) => {
                  // reject(e);
                  if (e) {
                    this.$message({
                      type: "error",
                      message: "删除失败!",
                    });
                  }
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！",
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "删除中...";
          new MyApis.TbTourScenicApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.loading = false;
              this.search();
            })
            .catch((e) => {
              this.loading = false;
              console.log(e);
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd");
    }
  }
};
</script>
<style lang="scss">

</style>